import { STORIES } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";

export const Stories = () => (
  <section id="stories" data-testid="stories-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <SectionHead
          num="09"
          eyebrow="Field Journal"
          title="Stories From the Heartland"
          copy="Notes, guides and dispatches from the forests and rivers we call home."
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {STORIES.map((s, i) => (
          <FadeUp key={s.title} delay={i * 0.1}>
            <article
              data-testid={`story-card-${i + 1}`}
              className="group border border-gold/10 hover:border-gold/40 bg-forest-900/40 transition-colors duration-500 overflow-hidden cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <Img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <span className="absolute top-4 left-4 glass-panel px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                  {s.tag}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-serif text-xl sm:text-2xl text-cream leading-snug group-hover:text-gold transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="text-sm text-cream/55 mt-3 leading-relaxed">{s.excerpt}</p>
                <span className="block mt-5 font-mono text-[10px] uppercase tracking-[0.22em] text-fog">
                  {s.read}
                </span>
              </div>
            </article>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
